import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

const AaliGoldJewelz = () => {
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => { if (entry.isIntersecting) entry.target.classList.add('visible'); });
    }, { threshold: 0.2 });
    document.querySelectorAll('.scroll-reveal, .service-item, .info-card').forEach(el => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <div className="company-hero" style={{ background: 'linear-gradient(135deg, #5c3d1a, #8b691b)' }}>
        <div className="hero-content">
          <h1>AALI GOLD JEWELZ</h1>
          <p>Premium jewelry brand offering exquisite designs crafted with the finest materials</p>
        </div>
      </div>
      <div className="company-content">
        <div className="container">
          <div className="company-grid">
            <div className="left scroll-reveal">
              <h2>About AALI GOLD JEWELZ</h2>
              <p>AALI GOLD JEWELZ represents the pinnacle of luxury and craftsmanship. Each piece in our collection is meticulously designed and crafted to celebrate life's precious moments with timeless elegance.</p>
              <h3>Our Services</h3>
              <div className="services-list">
                <div className="service-item"><span>✔</span> Bespoke Jewellery Design</div>
                <div className="service-item"><span>✔</span> Bridal Collections</div>
                <div className="service-item"><span>✔</span> Fine Jewellery</div>
                <div className="service-item"><span>✔</span> Luxury Watches</div>
                <div className="service-item"><span>✔</span> Jewellery Customization</div>
              </div>
            </div>
            <div className="info-card scroll-reveal">
              <h4>Company Info</h4>
              <div className="info-block">
                <span className="info-label">Industry</span>
                <strong className="info-value">Luxury & Retail</strong>
              </div>
              <div className="info-block">
                <span className="info-label">Parent Company</span>
                <strong className="info-value">AALI GROUP</strong>
              </div>
              <div className="actions">
                <Link to="/contact" className="btn-primary">Get in Touch</Link>
                <Link to="/coming-soon" className="btn-primary">Visit Main Website</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AaliGoldJewelz;